import { ComponentPropsWithoutRef, MouseEventHandler } from "react";
import IntervalActionButton from "../interval-action-button";
import { ReactComponent as OutlineTrash1 } from "assets/svg/outline-trash-1.svg";

type Props = Omit<
  ComponentPropsWithoutRef<typeof IntervalActionButton>,
  "Icon"
> & { onClick: MouseEventHandler };
const RemoveTimeslot = (props: Props) => (
  <IntervalActionButton {...props} Icon={OutlineTrash1} />
);

export default RemoveTimeslot;
